export const segmentTransition = (context) => (id, prev, next) => ({
    type: "JOINT.SESSION.FLOW_SEGMENT_CHANGED",
    payload: { id, prev, next },
    context,
});
